import { render, staticRenderFns } from "../templates/normal_fcont_192.html?vue&type=template&id=01dc5e34&scoped=true&"
import script from "./normal_fcont_192.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_192.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dc5e34",
  null
  
)

export default component.exports